import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createSlots as _createSlots, normalizeStyle as _normalizeStyle, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "crm:mt-[80px] crm:px-4 crm:ml-[3px] crm:relative" }
const _hoisted_2 = {
  key: 0,
  class: "crm:text-primary! crm:font-bold! crm:text-xl! crm:capitalize"
}
const _hoisted_3 = {
  key: 0,
  class: "crm:mt-3"
}

import {computed, inject, onMounted, provide, ref, watch} from "vue";
import {delete_cross} from '../../svg/svgs.js'
import AppHelperItem from "./AppHelperItem.vue";


export default {
  __name: 'TheHelper',
  props: {
  /**
   * Json di Helper da mostrare
   */
  list: {
    type: Object,
    default() {
      return {}
    }
  },
  /**
   * Se true vuol dire che accetta raggruppamenti di liste di helper
   */
  isClosing: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:list'],
  setup(__props, { emit: __emit }) {

/**
 * @doc Renderizza una sidebar che contiene una lista di informazioni utili inerenti alla sezione.
 * E' possibile collegare tale informazione ad un campo di un form nella pagina.
 * Una volta collegato apparirà affianco al campo un icona di info, che una volta premuta farà comparire la sidebar con la info relativa evidenziata.
 */
const props = __props

const emits = __emit

/**
 * @inject {$DesignSystem} recupera la lista dei colori/configurazioni del design system
 */
const $DesignSystem = inject('$DesignSystem')

/**
 * @inject {helperActived}
 */
const helperActived = inject('helperActived');

/**
 * @inject {showHelperSidebar}
 */
const showHelperSidebar = inject('showHelperSidebar');

/**
 * @inject {updateShow}
 */
const updateShow = inject('updateShow');

/**
 * @inject {updateHelperActived}
 */
const updateHelperActived = inject('updateHelperActived');

let section = (window.location.pathname).replace('/', '')
let helperList = computed({
  get: () => props.isClosing ? convertListToTabs(props.list) : props.list,
  set: (newValue) => emits('update:list', newValue)
})

function convertListToTabs(list) {
  let tabs = [];
  Object.keys(list).forEach((listKey) => {
    tabs.push({
      title: listKey,
      controls: listKey,
      helpers: list[listKey]
    })
  })

  return tabs;
}

watch(helperActived, (newValue) => {
  if(newValue && props.isClosing) {
    (helperList.value).forEach((help) => {
      if(help.helpers[newValue]) {
        helpertabAttiva.value = help.controls;
      }
    })
  }


  updateShow(!!newValue)
})

let barWidth = ref(480)
let m_pos;

function resize(event){
  const dx = m_pos - event.x;
  m_pos = event.x;
  barWidth.value = barWidth.value + dx;
}

function mouseDownEvent(event) {
  event.preventDefault();
  if (event.offsetX < 2) {
    m_pos = event.x;
    document.addEventListener("mousemove", resize, false);
  }
}

function mouseUpEvent(event) {
  event.preventDefault();
  document.removeEventListener("mousemove", resize, false);
}

const helperOver = ref('')

const updateHaveHelper = inject('updateHaveHelper')
onMounted(() => {
  updateHaveHelper(props.list && Object.keys(props.list).length > 0)
})

function closeHelperSidebar() {
  updateHelperActived(false);
  updateShow(false)
}

/**
 * @provides {helperOver} Espone il valore dell'hover sull'helper
 */
provide('helperOver', computed(() => helperOver.value))

const helpertabAttiva = ref(null)

return (_ctx, _cache) => {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_tabs = _resolveComponent("base-tabs")

  return (_openBlock(), _createBlock(_Transition, {
    "enter-active-class": "crm:duration-300 crm:ease-out",
    "enter-from-class": "crm:transform crm:opacity-0 crm:w-0",
    "enter-to-class": "crm:opacity-100 crm:w-[30rem]",
    "leave-active-class": "crm:duration-200 crm:ease-in",
    "leave-from-class": "crm:opacity-100 crm:w-[30rem]",
    "leave-to-class": "crm:transform crm:opacity-0 crm:w-0"
  }, {
    default: _withCtx(() => [
      (_unref(showHelperSidebar))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            style: _normalizeStyle(_unref(barWidth) ? {maxWidth: _unref(barWidth)+'px'} : {}),
            class: _normalizeClass([{'crm:w-[30rem]': !_unref(barWidth)}, "crm:z-40 crm:bg-white crm:shadow-lg crm:fixed crm:top-0 crm:right-0 crm:h-full crm:transition-all crm:ease-out crm:border-r crm:border-solid crm:overflow-y-scroll"])
          }, [
            _createElementVNode("div", {
              class: "crm:w-[2px] crm:transition-[3px] crm:duration-400 crm:h-full crm:absolute crm:left-0 crm:top-0 crm:cursor-move crm:hover:cursor-move crm:bg-ternary crm:hover:bg-primary",
              onMousedown: mouseDownEvent,
              onMouseup: mouseUpEvent
            }, null, 32 /* NEED_HYDRATION */),
            _createElementVNode("div", _hoisted_1, [
              _createVNode(_component_base_icon, {
                icon: _unref(delete_cross),
                onClick: _withModifiers(closeHelperSidebar, ["prevent"]),
                class: "crm:absolute crm:right-4 crm:cursor-pointer"
              }, null, 8 /* PROPS */, ["icon"]),
              (!__props.isClosing)
                ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_unref(section)) + ": ", 1 /* TEXT */))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", {
                class: _normalizeClass({'crm:pt-8': __props.isClosing})
              }, [
                (!__props.isClosing)
                  ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(helperList), (item, itemKey) => {
                        return (_openBlock(), _createBlock(AppHelperItem, {
                          item: item,
                          "item-key": itemKey,
                          class: _normalizeClass(["crm:mb-1 crm:mt-2 crm:p-2", {'crm:bg-zinc-100 crm:border-l-4 crm:border-l-primary crm:rounded-sm': itemKey === (_unref(helperActived) || helperOver.value), 'crm:bg-white crm:border-l-4 crm:border-l-white': _unref(helperActived) && itemKey !== _unref(helperActived)}]),
                          onMouseover: $event => (helperOver.value = itemKey),
                          onMouseleave: _cache[0] || (_cache[0] = $event => (helperOver.value = ''))
                        }, null, 8 /* PROPS */, ["item", "item-key", "class", "onMouseover"]))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ]))
                  : _createCommentVNode("v-if", true),
                (__props.isClosing)
                  ? (_openBlock(), _createBlock(_component_base_tabs, {
                      key: 1,
                      tabs: _unref(helperList),
                      "tab-attiva": helpertabAttiva.value,
                      "onUpdate:tabAttiva": _cache[2] || (_cache[2] = $event => ((helpertabAttiva).value = $event)),
                      class: "pb-4"
                    }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                      _renderList(_unref(helperList), (item) => {
                        return {
                          name: item.controls,
                          fn: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.helpers, (help, helpKey) => {
                              return (_openBlock(), _createBlock(AppHelperItem, {
                                item: help,
                                "item-key": helpKey,
                                class: _normalizeClass(["crm:mb-1 crm:p-2 crm:mt-2", {'crm:bg-zinc-100 crm:border-l-4 crm:border-l-primary crm:rounded-sm': helpKey === (_unref(helperActived) || helperOver.value), 'crm:bg-white crm:border-l-4 crm:border-l-white': _unref(helperActived) && helpKey !== _unref(helperActived)}]),
                                onMouseover: $event => (helperOver.value = helpKey),
                                onMouseleave: _cache[1] || (_cache[1] = $event => (helperOver.value = ''))
                              }, null, 8 /* PROPS */, ["item", "item-key", "class", "onMouseover"]))
                            }), 256 /* UNKEYED_FRAGMENT */))
                          ])
                        }
                      })
                    ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["tabs", "tab-attiva"]))
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */)
            ])
          ], 6 /* CLASS, STYLE */))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}
}

}